import React from 'react';
import classnames from 'classnames';
import noop from '../utils/noop';
import Icon from '../icon';
import Text from '../text';
import Button from '../button';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function UpgradePopover({ onUpgradeClick = noop, captions, animateId = null, id }) {
  const animated = animateId === id;

  return (
    <div className={classnames('ws-upgrade-popover', animated && 'ws-upgrade-popover--animated')}>
      <div className="ws-upgrade-popover__content">
        {/* @ts-ignore TS(2322): Type '{ size: string; glyph: string; className: st... Remove this comment to see the full error message */}
        <Icon size="25" glyph="arrow-up-circle" className="ws-upgrade-popover__icon" />
        <div className="ws-upgrade-popover__container">
          <Text className="ws-upgrade-popover__text" type="regular">
            {captions.description}
          </Text>
          <Button type="cta" className="ws-upgrade-popover__button" onClick={onUpgradeClick}>
            {captions.upgrade}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default UpgradePopover;
